/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AssignedInsuranceItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Carrier from './Carrier/index'
import EffectiveDate from './EffectiveDate/index'
import Employer from './Employer/index'
import Inactivate from './Inactivate/index'
import InsurancePlan from './InsurancePlan/index'
import InsuredTreatments from './InsuredTreatments/index'
import MemberId from './MemberId/index'
import PlanNumber from './PlanNumber/index'
import React from 'react'
import Reactivate from './Reactivate/index'
import Remove from './Remove/index'
import Subscriber from './Subscriber/index'
import Subscription from './Subscription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AssignedInsuranceItem({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem",
  hovered
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="AssignedInsuranceItem.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z7StjM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z7StjM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-Z7StjM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-Z7StjM': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Subscriber
  viewPath={`${viewPath}/Subscriber`}
/>
<PlanNumber
  viewPath={`${viewPath}/PlanNumber`}
/>
<Carrier
  viewPath={`${viewPath}/Carrier`}
/>
<Employer
  viewPath={`${viewPath}/Employer`}
/>
<MemberId
  viewPath={`${viewPath}/MemberId`}
/>
<EffectiveDate
  viewPath={`${viewPath}/EffectiveDate`}
/>
<div
  data-testid="AssignedInsuranceItem.Horizontal:1"
  data-view-path={viewPath}
 hovered={hovered}
 className={`views-block ${styles.Horizontal1}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<Subscription
  viewPath={`${viewPath}/Subscription`}
/>
<InsurancePlan
  viewPath={`${viewPath}/InsurancePlan`}
/>
<Inactivate
  viewPath={`${viewPath}/Inactivate`}
/>
<Reactivate
  viewPath={`${viewPath}/Reactivate`}
/>
<Remove
  viewPath={`${viewPath}/Remove`}
/>
<InsuredTreatments
  viewPath={`${viewPath}/InsuredTreatments`}
/>
{children}
</React.Fragment>)
}